import axios from 'axios';

let prefix = "/unit-stat"

const UnitStatApi = {
	listUnitStat(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getUnitStat(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveUnitStat(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createUnitStat(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateUnitStat(payload) {
		return axios.post(prefix + "/update", payload)
	},
	syncFromGoogleSheet(payload) {
		return axios.post(prefix + "/sync-google-sheet", payload)
	},
}

export default UnitStatApi;